
import { i18nText } from '@/locales';

import {Component, Vue, Prop} from 'vue-property-decorator';
import { Chart } from 'chart.js';

@Component({
})
export default class LineChartComponent extends Vue {
    @Prop() index!: string | number;
    @Prop() data!: Record<string, any>;

    chartType = 'line';
    chartLabels: any = [];
    chartName = 'chart_';
    inflowData: any = [];
    outflowData: any = [];
    scales = {
        yAxes: [{
            gridLines: {
                drawOnChartArea: false,
                display: false
            }
        }],
        xAxes: [{
            // ticks: {
            //     callback: function(val: any, index: any): any {
            //         console.log(val);
            //         return index % 3 === 0 ? val : '';
            //     },
            // },
            // gridLines: {
            //     callback: function(val: any, index: any): any {
            //         console.log(val);
            //     },
            // }
        }]};

    created(): void {
        this.chartName = this.chartName + this.index;
        if(this.data){
            let $this = this;
            Object.keys(this.data).map(function(objectKey, index) {
                var value = $this.data[objectKey];
                $this.chartLabels.push(objectKey);
                $this.inflowData.push(value.inflow);
                $this.outflowData.push(value.outflow);
            });
        }
    }

    mounted(): void {

        var ctx = <HTMLCanvasElement> document.getElementById(this.chartName);
        var canvas = <string | HTMLCanvasElement | CanvasRenderingContext2D | ArrayLike<HTMLCanvasElement | CanvasRenderingContext2D>> ctx.getContext('2d');

        var myChart = new Chart(canvas, {
            type: this.chartType,
            data: {
                labels: this.chartLabels,
                datasets: [{
                    label: i18nText("Доходы"),
                    data: this.inflowData,
                    showLine: true,
                    pointRadius: 5,
                    pointBorderColor: 'rgba(0, 0, 0, 0)',
                    pointBackgroundColor: 'rgba(0, 0, 0, 0)',
                    backgroundColor: 'rgba(250, 84, 28, 0.1)',
                    borderColor: 'rgba(250, 84, 28, 1)',
                    borderWidth: 1
                },
                {
                    label: i18nText("Расходы"),
                    data: this.outflowData,
                    showLine: true,
                    pointRadius: 5,
                    pointBorderColor: 'rgba(0, 0, 0, 0)',
                    pointBackgroundColor: 'rgba(0, 0, 0, 0)',
                    backgroundColor: 'rgba(51, 137, 228, 0.1)',
                    borderColor: 'rgba(51, 137, 228, 1)',
                    borderWidth: 1
                }]
            },
            options: {
                scales: this.scales
            }
        });

    }
}
